module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-lg-13426495.svg";